import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import SubmitButton from 'webapp/components/submit-button';

import type SourceType from 'webapp/models-custom/source-type';

interface CommonAskToConnectButtonComponentInterface {
	Element: HTMLAnchorElement;
	Args: {
		model: SourceType;
	};
}

export default class CommonAskToConnectButtonComponent extends Component<CommonAskToConnectButtonComponentInterface> {
	@service('connect') declare connectService: Service.Connect;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	get buttonTheme(): string {
		return this.currentUserService.isVerified ? 'blue-outlined' : 'grey-outlined';
	}

	@action
	helpConnect() {
		if (this.currentUserService.handleDemo()) {
			return;
		}

		if (this.currentUserService.isVerified) {
			this.args.model.requestConnect();
		} else {
			this.connectService.openEmailVerificationInfoPopup();
		}
	}

	<template>
		<SubmitButton
			@text="Ask to connect"
			@noDelay={{true}}
			@onTrigger={{this.helpConnect}}
			@theme={{this.buttonTheme}}
		/>
	</template>
}
